import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";
import Login from "./admin/Login";
import Layout from "./common/Layout";
import Dashboard from "./Dashboard";
import Profile from "./admin/Profile";
import Privacy from "./admin/Privacy";
import AboutUs from "./admin/AboutUs";
import Terms from "./admin/Terms";
import Password from "./admin/Password";
import RestaurantList from './Restaurant/RestaurantList';
import ViewRestaurant from './Restaurant/ViewRestaurant';
import WaiterList from './Restaurant/WaiterList';
import ViewWaiter from './Restaurant/ViewWaiter';
import EditWaiter from './Restaurant/EditWaiter';
import MenuItems from './Restaurant/MenuItems';
import ViewMenu from './Restaurant/ViewMenu';
import ScrollToTop from './utils/ScrollToTop';
import AddWaiter from './Restaurant/AddWaiter';
import AddRestaurant from './Restaurant/AddRestaurant';
import EditRestaurant from './Restaurant/EditRestaurant';
import CategoryList from './Category/CategoryList';
import ViewCategory from './Category/ViewCategory';
import ContactUs from './ContactUs/ContactUs';
import ViewContactUs from './ContactUs/ViewContactUs';
import RequestList from './Request/RequestList';
import MenuLinks from './Restaurant/MenuLinks';
const App = () => {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
            <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
            <Route path="/privacypolicy" element={<PrivateRoute element={<Privacy />} />} />
            <Route path="/aboutus" element={<PrivateRoute element={<AboutUs />} />} />
            <Route path="/terms&conditions" element={<PrivateRoute element={<Terms />} />} />
            <Route path="/changepassword" element={<PrivateRoute element={<Password />} />} />
            <Route path="/restaurantlist" element={<PrivateRoute element={<RestaurantList />} />} />
            <Route path="/viewrestaurant/:_id" element={<PrivateRoute element={<ViewRestaurant />} />} />
            <Route path="/waiterlist/:_id" element={<PrivateRoute element={<WaiterList />} />} />
            <Route path="/addwaiter/:_id" element={<PrivateRoute element={<AddWaiter />} />} />
            <Route path="/editwaiter/:_id" element={<PrivateRoute element={<EditWaiter />} />} />
            <Route path="/viewwaiter/:_id" element={<PrivateRoute element={<ViewWaiter />} />} />
            <Route path="/menuitems/:_id" element={<PrivateRoute element={<MenuItems />} />} />
            <Route path="/menulinks/:_id" element={<PrivateRoute element={<MenuLinks />} />} />
            <Route path="/viewMenu/:_id" element={<PrivateRoute element={<ViewMenu />} />} />
            <Route path="/addrestaurant" element={<PrivateRoute element={<AddRestaurant />} />} />
            <Route path="/editrestaurant/:_id" element={<PrivateRoute element={<EditRestaurant />} />} />
            <Route path="/categorylist/:_id" element={<PrivateRoute element={<CategoryList />} />} />
            <Route path="/viewcategory/:_id" element={<PrivateRoute element={<ViewCategory />} />} />
            <Route path="/contactus" element={<PrivateRoute element={<ContactUs />} />} />
            <Route path="/viewcontactus/:_id" element={<PrivateRoute element={<ViewContactUs />} />} />
            <Route path="/requestlist/:_id" element={<PrivateRoute element={<RequestList />} />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
